import { useState } from 'react'
import { LegacyAntdModal } from 'components/LegacyAntdModal/LegacyAntdModal'
import Styles from './RestoreVersionModal.module.scss'

import { RestoreVersionModalProps } from './Types'
import { CloseButton } from 'components/Buttons/CloseButton'
import { ArticleClient } from 'api/clients/ArticleClient'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { useArticleMeta } from 'hooks/useArticleMeta'
import { generatePath, useHistory } from 'react-router-dom'
import { DOC_PATH } from 'paths'
import { displayDateTime } from 'utils/dates'
import { reportError } from 'utils/error'
import { useAuth } from 'hooks/UseAuth'
import { showToastMessage } from 'common/ToastMessage/ShowToastMessage'

const RestoreVersionModal = ({ visible, setVisible, onClose, event }: RestoreVersionModalProps) => {
  const auth = useAuth()
  const history = useHistory()
  const [submitting, setSubmitting] = useState(false)
  const { article, id, timestamp } = event
  const articleMeta = useArticleMeta(article.key)
  const eventTitle = event.name || displayDateTime(timestamp)
  const handleClose = () => {
    if (submitting) {
      return
    }
    onClose?.()
    setVisible(false)
  }

  const submit = async () => {
    if (submitting) {
      return
    }

    setSubmitting(true)
    const res = await ArticleClient.restoreEvent(article.key, id)
    if (res.type === SUCCESS_RESPONSE_TYPE) {
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      history.push(generatePath(DOC_PATH, { slug: articleMeta!.slug }))
      showToastMessage(`🎉 Restored document to: "${eventTitle}"`, 'success', undefined, 5)
    } else {
      setSubmitting(false)
      showToastMessage('An error occurred! Our team has been notified and we are looking into it.', 'error')
      reportError('Failed to restore event from activity screen', {
        severity: 'error',
        metaData: { event },
        user: { id: auth?.id },
      })
    }
  }

  return (
    <LegacyAntdModal
      visible={visible}
      onCancel={handleClose}
      wrapClassName={Styles.container}
      closable={false}
      width={650}
    >
      <div className={Styles.header}>
        <h2>Restore from this event?</h2>
        <CloseButton onClick={handleClose} />
      </div>
      <div className={Styles.body}>The current document will revert to the state of "{eventTitle}".</div>
      <div className={Styles.footer}>
        <div className={Styles.footerLeft} />
        <button id="restore-version-button" className={Styles.actionButton} onClick={submit} disabled={submitting}>
          {submitting ? 'Restoring...' : 'Restore'}
        </button>
      </div>
    </LegacyAntdModal>
  )
}

export { RestoreVersionModal }
